import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { GlobalService } from './global.service';

export interface Permission {
  entity: string;
  canview: boolean;
  canread: boolean;
  cancreate: boolean;
  canupdate: boolean;
  candelete: boolean;
  canexecute: boolean;
  rowscope?: 'all' | 'assigned' | 'own';
}

export type PermissionMap = Record<string, Permission>;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  private map: PermissionMap = {};
  private loaded = false;
  private globalService = inject(GlobalService);
  constructor(private httpClient: HttpClient) {}

  private baseUrl = environment.base_url + '/me/permissions';

  // getPermissions() {
  //   return this.httpClient.get<any>(this.baseUrl, this.httpOptions);
  // }

  async loadPermissions(): Promise<void> {
    // console.log('Loading permissions...');
    if (this.loaded) return;
    this.map = {};
    const resp = await firstValueFrom(
      this.httpClient.get<{ permissions: PermissionMap }>(
        this.baseUrl,
        this.httpOptions,
      ),
    );
    this.map = resp.permissions || {};
    this.loaded = true;
    this.globalService.setPermissions(true);
    // console.log('Permissions loaded:', this.map);
  }

  reset(): void {
    this.map = {};
    this.loaded = false;
    this.globalService.setPermissions(false);
  }

  has(entity: string, flag: keyof Permission = 'canview'): boolean {
    const p = this.map[entity?.toLowerCase()];
    return !!(p && p[flag]) === true;
  }

  hasAi(childEntity: string, flag: 'canview' | 'canexecute' = 'canview'): boolean {
    return this.has('ai', flag) && this.has(childEntity, flag);
  }

  getMap(): PermissionMap {
    return this.map;
  }
}
